module.exports = __webpack_public_path__ + "img/1bca5cb.jpg";